class QuickVariantSelector extends HTMLElement{
    constructor(){
        super();
    }
    connectedCallback() {
        this.clickOnSelectOption();
    }
    clickOnSelectOption() {
        let varBtn = this.querySelectorAll('.quickAddOptions-btn');
        varBtn.forEach(variant => {
            variant.addEventListener('click', async (e)=>{
                e.preventDefault();
                let loadingCartBlock = document.querySelector('.WI_loadingCartItemBlock');
                let emptyCart =  document.querySelector('.WI_cartDrawerin_cart_empty');
                if (loadingCartBlock != null) {
                    loadingCartBlock.style.display = "block";
                }
                if (emptyCart != null) {
                    emptyCart.style.display = "none";
                }
                const openCart = new CustomEvent("opencart", { bubbles: true });
                document.dispatchEvent(openCart);
                let variantId = variant.parentElement.querySelector('select').value;
                let formData = {
                    'items': [{
                        "id": variantId,
                        "quantity": 1
                    }]
                };
                await fetch('/cart/add',{
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                });   
                const updateCart = new CustomEvent("updateCart", { bubbles: true });
                document.dispatchEvent(updateCart);
            });
        });
        this.querySelectorAll('select').forEach((select)=>{
          select.addEventListener('change', async (e)=>{
            varBtn.forEach(variant => {
              variant.removeAttribute('disabled');
            });
          });
        });
        document.querySelectorAll('.MA-quickAdd-btn').forEach((btn)=>{
          btn.addEventListener('click', async (e)=>{
            btn.nextElementSibling.style.display = 'flex';
            btn.style.display = 'none';
          });
        });
        document.querySelectorAll('.MA-quickOption-btn-close').forEach((btn)=>{
          btn.addEventListener('click', async (e)=>{
            btn.parentElement.style.display = 'none';
            btn.parentElement.previousElementSibling.style.display = 'block';
          });
        });
    };
}

customElements.define("quick-variant-selector", QuickVariantSelector);